module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', [_c('pl-spinner', {
    staticClass: "x2",
    staticStyle: {
      "margin": "auto",
      "margin-top": "200px"
    }
  })], 1) : _c('div', [_c('table', {
    staticClass: "integrations-table mv4 w-100"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.providers), function(provider, index) {
    return _c('tr', {
      key: index,
      staticClass: "row no-margin"
    }, [_c('td', {
      staticClass: "col-xs-4 truncate-text flex"
    }, [_c('pl-menu', {
      attrs: {
        "direction": "left",
        "menuSize": 4
      }
    }, [_c('div', {
      attrs: {
        "slot": "menu_trigger"
      },
      slot: "menu_trigger"
    }, [_c('pl-button', {
      staticClass: "pl-icon pl-no-margin"
    }, [_c('i', {
      staticClass: "fas fa-ellipsis-v"
    })])], 1), _vm._v(" "), _c('ul', {
      attrs: {
        "menu-content": ""
      }
    }, [_c('li', {
      staticClass: "px-2.5 py-1 cursor-pointer",
      on: {
        "click": function($event) {
          return _vm.addIntegrationID(provider.integration_id)
        }
      }
    }, [_c('span', [_vm._v("Add Integration ID")])])])]), _vm._v(" "), _c('img', {
      staticClass: "mr-2",
      attrs: {
        "src": provider.icon_url,
        "height": "40px",
        "width": "40px"
      }
    }), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "font-semibold db"
    }, [_vm._v(_vm._s(provider.name))]), _vm._v(" "), _c('a', {
      staticClass: "view-guide",
      attrs: {
        "href": ("https://ed.link/docs/schools/connect/" + (provider.name.toLowerCase())),
        "target": "_blank"
      }
    }, [_vm._v("\n                View Guide\n              ")])])], 1), _vm._v(" "), _c('td', {
      staticClass: "flex col-xs-2 center-xs justify-center"
    }, [(provider.class_rostering) ? _c('img', {
      attrs: {
        "src": "/static/live_discussion/check_mark.svg",
        "alt": "",
        "height": "20px",
        "width": "20px"
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "flex col-xs-2 center-xs justify-center"
    }, [(provider.assignment_and_assessment_sync) ? _c('img', {
      attrs: {
        "src": "/static/live_discussion/check_mark.svg",
        "alt": "",
        "height": "20px",
        "width": "20px"
      }
    }) : _c('span', {
      staticClass: "b"
    }, [_vm._v(" - ")])]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-2 center-xs"
    }, [(provider.school_connected) ? _c('span', {
      staticClass: "td-connected"
    }, [_vm._v("\n              Connected\n            ")]) : _c('span', {
      staticClass: "b"
    }, [_vm._v("Not Connected")])]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-2 center-xs"
    }, [(provider.integration_id) ? _c('pl-button', {
      staticClass: "b",
      staticStyle: {
        "margin": "0",
        "color": "#78bec8",
        "font-size": "18px"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.$emit(
            'import_courses_modal',
            provider.integration_id,
            provider.name
          )
        }
      }
    }, [_vm._v("\n              Run Import\n            ")]) : _c('span', {
      staticClass: "b"
    }, [_vm._v(" - ")])], 1)])
  }), 0)])]), _vm._v(" "), (_vm.add_integration_modal) ? _c('pl-dialog', {
    attrs: {
      "size": "xs",
      "title": 'Edlink Integration ID',
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        _vm.add_integration_modal = false
      }
    }
  }, [_c('div', {
    staticClass: "p-4"
  }, [_c('pl-input', {
    attrs: {
      "labelText": "Integration Id"
    },
    model: {
      value: (_vm.integration_id),
      callback: function($$v) {
        _vm.integration_id = $$v
      },
      expression: "integration_id"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center-xs mt4"
  }, [_c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.saveIntegrationId.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          SAVE\n        ")])], 1)], 1)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "row no-margin middle-xs"
  }, [_c('td', {
    staticClass: "col-xs-4"
  }, [_vm._v("Integration")]), _vm._v(" "), _c('td', {
    staticClass: "col-xs-2 center-xs"
  }, [_vm._v("Class Rostering")]), _vm._v(" "), _c('td', {
    staticClass: "col-xs-2 center-xs"
  }, [_vm._v("Assignment & Assessment Sync")]), _vm._v(" "), _c('td', {
    staticClass: "col-xs-2 center-xs"
  }, [_vm._v("Connected?")]), _vm._v(" "), _c('td', {
    staticClass: "col-xs-2 center-xs"
  }, [_vm._v("Import")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-148768f9!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/integrations/integrationsTable.vue
// module id = 2105
// module chunks = 61